<template>
    <cic-popup
        :title="profile.profileId ? 'Edit User Profile' : 'New User Profile'"
        :saveable="editing"
        :save-button-label="profile.orgId === $store.user.orgId ? 'Save' : 'Save As New'"
        class="edit-rights-profile"
        @blur="$emit('blur')"
        @input="$emit('input')"
    >
        <div class="item-form">
            <ul>
                <li class="form-label-first">
                    {{ $t('Name') }}
                </li>
                <li>
                    <cic-textbox
                        id="profile_name"
                        :value="profile.name"
                        :enabled="editing"
                        :maxlength="255"
                        @input="(val) => updateFieldValue('name', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Allow use by suborganisations') }}
                </li>
                <li>
                    <CicCheckbox
                        id="profile_suborgs"
                        :value="profile.allowForSubOrgs"
                        :enabled="editing"
                        @input="(val) => updateFieldValue('allowForSubOrgs', val)"
                    />
                </li>
            </ul>
        </div>

        <div id="rights_view">
            <div id="divRightProducts">
                <ul>
                    <li
                        v-for="product in Object.keys(definitions)"
                        :class="{ selected: selected === product }"
                        @click="selected = product"
                    >
                        <div>{{ $t(product) }}</div>
                    </li>
                </ul>
            </div>
            <div id="divRights">
                <div v-if="selected !== null">
                    <ElAlert
                        v-if="selected === 'RedResponse' && source !== 'usermanagement'"
                        id="update-alert"
                        :closable="false"
                        :title="$t('REDRESPONSE_RIGHTS_WARNING')"
                        type="warning"
                        show-icon
                        center
                    />
                    <ul v-if="editing && rightsTemplates.length > 0" class="selectall">
                        <li>
                            <label>{{ $t('Template') }}</label>
                        </li>
                        <li>
                            <cic-select
                                id="profile_template"
                                :options="
                                    rightsTemplates.map((x) => {
                                        return { value: x.templateId, label: x.name };
                                    })
                                "
                                @input="applyTemplate"
                            />
                        </li>
                    </ul>
                    <div v-if="editing" class="selectall">
                        <label>{{ $t('Select All') }}</label>
                        <cic-checkbox id="chkSelectAll" :value="allSelected" @click="selectAll" />
                    </div>
                    <ul class="ul-user-rights">
                        <li
                            v-for="(rights, section) in definitions[selected]"
                            class="rightSection"
                            style="display: inline-block"
                        >
                            <h4>{{ $t(section) }}</h4>
                            <div class="sub-container">
                                <ul>
                                    <li v-for="(label, name) in rights">
                                        <label>{{ $t(label) }}</label>
                                        <cic-checkbox
                                            :value="profile.rights[selected][name]"
                                            :enabled="editing"
                                            @input="(val) => updateRight(selected, name, val)"
                                        />
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </cic-popup>
</template>

<script>
    import { ElAlert } from 'element-plus';
    import CicPopup from '@/components/CicPopup';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicSelect from '@/components/inputs/CicSelect';
    import CicTextbox from '@/components/inputs/CicTextbox';

    export default {
        name: 'EditRightsProfile',
        components: {
            CicCheckbox,
            CicPopup,
            CicSelect,
            CicTextbox,
            ElAlert,
        },
        props: {
            profile: {
                type: Object,
                required: true,
            },
            definitions: {
                type: Object,
                required: true,
            },
            source: {
                type: String,
                default: '',
            },
            templates: {
                type: Array,
                required: true,
            },
        },
        emits: ['blur', 'change', 'input'],
        data() {
            return {
                selected: null,
            };
        },
        computed: {
            editing() {
                return (
                    this.profile &&
                    ((this.profile.profileId && this.$store.hasRight('EDIT_USER_PROFILES')) ||
                        (!this.profile.profileId && this.$store.hasRight('ADD_USER_PROFILES')))
                );
            },
            allSelected() {
                return Object.values(this.profile.rights[this.selected]).filter((x) => x === false).length === 0;
            },
            rightsTemplates() {
                return this.templates.filter((x) => Object.keys(x.rights).includes(this.selected));
            },
        },
        created() {
            this.selected = Object.keys(this.definitions)[0];
        },
        methods: {
            applyTemplate(val) {
                let rights = this.templates.find((x) => x.templateId === val).rights[this.selected];
                const profileRights = JSON.parse(JSON.stringify(this.profile.rights));
                Object.keys(this.profile.rights[this.selected]).forEach((x) => {
                    profileRights[this.selected][x] = rights.includes(x);
                });
                this.updateFieldValue('rights', profileRights);
            },
            selectAll(val) {
                const profileRights = JSON.parse(JSON.stringify(this.profile.rights));
                Object.keys(this.profile.rights[this.selected]).forEach((x) => {
                    profileRights[this.selected][x] = val;
                });
                this.updateFieldValue('rights', profileRights);
            },
            updateFieldValue(field, value) {
                this.$emit('change', field, value);
            },
            updateRight(section, name, value) {
                const profileRights = JSON.parse(JSON.stringify(this.profile.rights));
                profileRights[section][name] = value;
                this.updateFieldValue('rights', profileRights);
            },
        },
    };
</script>
